// ga.js
import ReactGA from 'react-ga4';

let secondaryTrackingId = null;

/**
 * Initializes up to two trackers:
 *   1) The main ID from .env
 *   2) An optional secondary ID if provided
 */
export const initializeGA = (secondaryID) => {
  secondaryTrackingId = secondaryID || null;

  // Always include your primary tracker
  const trackers = [
    { trackingId: process.env.REACT_APP_GA_TRACKING_ID }
  ];

  // Add the secondary only if passed in
  if (secondaryID) {
    trackers.push({ trackingId: secondaryID });
  }

  ReactGA.initialize(trackers);
};

/**
 * Send a pageview to the primary tracker by default.
 * If sendToSecondary === true and a secondary ID was initialized,
 * send to both trackers.
 */
export const trackPageView = (page, sendToSecondary = false) => {
  // By default, only primary
  const trackerIds = [process.env.REACT_APP_GA_TRACKING_ID];

  // If we want to include secondary, push that ID too
  if (sendToSecondary && secondaryTrackingId) {
    trackerIds.push(secondaryTrackingId);
  }

  ReactGA.send({ hitType: 'pageview', page }, trackerIds);
};

/**
 * Send an event in the form:
 *   sendEvent('event_name', { param1: val, param2: val }, sendToSecondary)
 * By default, only sends to primary.
 * If sendToSecondary = true, it also sends to the secondary (if initialized).
 */
export const sendEvent = (eventName, params = {}, sendToSecondary = false) => {
  // Always include the primary ID
  const trackerIds = [process.env.REACT_APP_GA_TRACKING_ID];

  // Optionally include secondary, if desired
  if (sendToSecondary && secondaryTrackingId) {
    trackerIds.push(secondaryTrackingId);
  }

  // This call signature is valid in react-ga4 v2+
  ReactGA.event(eventName, params, trackerIds);
};

/**
 * Set user_id on the primary tracker (and optionally the secondary).
 */
export const setUserID = (userID, sendToSecondary = false) => {
  const trackerIds = [process.env.REACT_APP_GA_TRACKING_ID];
  if (sendToSecondary && secondaryTrackingId) {
    trackerIds.push(secondaryTrackingId);
  }

  ReactGA.set({ user_id: userID }, trackerIds);
};

/**
 * Remove user_id from the primary (and optionally the secondary).
 */
export const removeUserID = (sendToSecondary = false) => {
  const trackerIds = [process.env.REACT_APP_GA_TRACKING_ID];
  if (sendToSecondary && secondaryTrackingId) {
    trackerIds.push(secondaryTrackingId);
  }

  ReactGA.set({ user_id: null }, trackerIds);
};

/**
 * Set user_properties on the primary (and optionally the secondary).
 */
export const setProperties = (userProperties, sendToSecondary = false) => {
  const trackerIds = [process.env.REACT_APP_GA_TRACKING_ID];
  if (sendToSecondary && secondaryTrackingId) {
    trackerIds.push(secondaryTrackingId);
  }

  ReactGA.set({ user_properties: userProperties }, trackerIds);
};
